import React from 'react';

/**
 * Price change from the close BEFORE the report to the latest close.
 *
 * The pre-report baseline is deliberate. A short report's largest single move is
 * frequently the publication day itself, and measuring from the entry price
 * misses it — SRAD (2026-04-22) reads -21.4% from the pre-report close and +1.5%
 * from entry, which inverts the sign. The trade-off is that nobody could have
 * shorted at the pre-report price, so this is the report's IMPACT, not a return
 * anyone captured.
 *
 * Colour follows the short's perspective: down is the thesis working, so red on
 * a fall would read backwards on a short-research product. Green = the stock
 * fell. The arrow carries the direction independently of colour, so the cell
 * still reads correctly in monochrome or for a colourblind reader.
 */
const PriceChangeSinceReport = ({ pct, preClose, latestClose, asOf }) => {
  if (pct === null || pct === undefined || pct === '') {
    return (
      <span className="text-gray-300 text-sm"
            title="No price history for this ticker yet — coverage is US-listed targets of 2026 reports">
        —
      </span>
    );
  }

  const n = Number(pct);
  if (!Number.isFinite(n)) return <span className="text-gray-300 text-sm">—</span>;

  const fell = n < 0;
  const fmt = (v) => (v == null ? '—' : Number(v).toFixed(2));
  const title =
    `${fmt(preClose)} before the report → ${fmt(latestClose)}` +
    (asOf ? ` (as of ${String(asOf).slice(0, 10)})` : '');

  return (
    <span
      className={`inline-flex items-baseline gap-1 font-mono text-sm tabular-nums ${
        fell ? 'text-green-700' : 'text-red-700'}`}
      title={title}
    >
      <span aria-hidden="true">{fell ? '▼' : '▲'}</span>
      {n > 0 ? '+' : ''}{n.toFixed(1)}%
    </span>
  );
};

export default PriceChangeSinceReport;
